import { Directive, ElementRef, NgZone, OnDestroy, OnInit, signal } from '@angular/core';

@Directive({
  selector: '[appTextClamp]',
  standalone: true,
  exportAs: 'appTextClamp',
})
export class TextClampDirective implements OnInit, OnDestroy {
  /** True only when content is actually overflowing (real DOM measurement). */
  readonly isClamped = signal(false);

  private readonly observer = new ResizeObserver(() =>
    this.zone.run(() => this.check())
  );

  constructor(private el: ElementRef<HTMLElement>, private zone: NgZone) {}

  ngOnInit(): void {
    this.observer.observe(this.el.nativeElement);
    // defer one frame so the browser has painted and measured the element
    requestAnimationFrame(() => this.zone.run(() => this.check()));
  }

  private check(): void {
    const el = this.el.nativeElement;
    // +1 to absorb sub-pixel rounding differences
    this.isClamped.set(el.scrollHeight > el.clientHeight + 1);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
